import { styled } from 'linaria/react';
import React, { CSSProperties, FC, memo } from 'react';
import CheckBox from '~/shared/components/shared/CheckBox';
import InputErrorMessage from '~/shared/components/shared/InputErrorMessage';
type Props = {
  agree: boolean;
  onClickAgree: () => void;
  agreeErrorMessage?: string;
  style?: CSSProperties;
};
const AgreeTermsOfUseAndPrivacyPolicy: FC<Props> = ({
  agree,
  onClickAgree,
  agreeErrorMessage,
  style
}) => {
  return <>
      <Container style={style}>
        <CheckBox isChecked={agree} onChecked={onClickAgree} readOnly style={{
        marginTop: '13px'
      }} />

        <AgreeText>
          <a href="https://www.cocolocala.jp/terms-of-use" target="_blank" rel="noopener noreferrer">
            利用規約
          </a>
          、
          <a href="http://www.hotspring-inc.jp/privacy-policy" target="_blank" rel="noopener noreferrer">
            個人情報保護方針
          </a>
          の内容を確認し同意する
        </AgreeText>
      </Container>
      {agreeErrorMessage && <InputErrorMessage style={{
      marginTop: '10px'
    }}>
          {agreeErrorMessage}
        </InputErrorMessage>}
    </>;
};
export default memo(AgreeTermsOfUseAndPrivacyPolicy);
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c14tstmi"
});
const AgreeText = /*#__PURE__*/styled("span")({
  name: "AgreeText",
  class: "a1byurgk"
});

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");